import { render, staticRenderFns } from "./VersionAlert.vue?vue&type=template&id=31828acc&scoped=true"
import script from "./VersionAlert.vue?vue&type=script&lang=ts"
export * from "./VersionAlert.vue?vue&type=script&lang=ts"
import style0 from "./VersionAlert.vue?vue&type=style&index=0&id=31828acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31828acc",
  null
  
)

export default component.exports